export default "__VITE_ASSET__BIJBbe7K__"